import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=42ff109d&"
import script from "./GlobalAlert.vue?vue&type=script&lang=js&"
export * from "./GlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ff109d')) {
      api.createRecord('42ff109d', component.options)
    } else {
      api.reload('42ff109d', component.options)
    }
    module.hot.accept("./GlobalAlert.vue?vue&type=template&id=42ff109d&", function () {
      api.rerender('42ff109d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/GlobalAlert.vue"
export default component.exports